!(function () {
  "use strict";
  customElements.get("zoom-images") ||
    customElements.define(
      "zoom-images",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.mediaContainer = this.closest(
              "[data-product-single-media-group]",
            )),
            (this.slider = this.mediaContainer?.querySelector(
              "[data-product-single-media-slider]",
            )),
            (this.zoomWrappers = this.mediaContainer?.querySelectorAll(
              "[data-zoom-wrapper]",
            )),
            (this.a11y = window.theme.a11y));
        }
        connectedCallback() {
          this.zoomWrappers.length &&
            this.zoomWrappers.forEach((e, t) => {
              e.addEventListener("click", (o) => {
                o.preventDefault();
                (this.slider && this.slider.classList.contains("is-moving")) ||
                  ((this.a11y.state.trigger = e), this.createZoom(t));
              });
            });
        }
        createZoom(e) {
          const t = this;
          let o = [],
            s = 0;
          this.zoomWrappers.forEach((i) => {
            const a = i.getAttribute("href"),
              r = parseInt(i.getAttribute("data-image-width")),
              l = parseInt(i.getAttribute("data-image-height"));
            if (
              (o.push({ src: a, w: r, h: l, msrc: a }),
              (s += 1),
              t.zoomWrappers.length === s)
            ) {
              let t = "pswp-zoom-gallery";
              1 === s && (t = "pswp-zoom-gallery pswp-zoom-gallery--single");
              const i = {
                barsSize: { top: 60, bottom: 60 },
                history: !1,
                focus: !1,
                index: e,
                mainClass: t,
                showHideOpacity: !0,
                showAnimationDuration: 250,
                hideAnimationDuration: 250,
                closeOnScroll: !1,
                closeOnVerticalDrag: !1,
                captionEl: !1,
                closeEl: !0,
                closeElClasses: ["caption-close"],
                tapToClose: !1,
                clickToCloseNonZoomable: !1,
                maxSpreadZoom: 2,
                loop: !0,
                spacing: 0,
                allowPanToNext: !0,
                pinchToClose: !1,
              };
              new window.theme.LoadPhotoswipe(o, i);
            }
          });
        }
      },
    );
})();
